module.exports = ":host /deep/ tabset .nav-tabs {\n  display: none;\n}\n"